/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ReferralInvitationStatusEnum {
    WaitingForPayment = 'waitingForPayment',
    ProtectionPeriod = 'protectionPeriod',
    Successful = 'successful',
    Canceled = 'canceled'
}

export function ReferralInvitationStatusEnumFromJSON(json: any): ReferralInvitationStatusEnum {
    return ReferralInvitationStatusEnumFromJSONTyped(json, false);
}

export function ReferralInvitationStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralInvitationStatusEnum {
    return json as ReferralInvitationStatusEnum;
}

export function ReferralInvitationStatusEnumToJSON(value?: ReferralInvitationStatusEnum | null): any {
    return value as any;
}

